// NOTA (sept 2026): initNuberaProductGift() se eliminó a pedido del cliente.
// Insertaba una franja amarilla ("2 regalos incluidos con tu compra") justo
// después del precio, duplicando el banner "2 regalos con tu compra" que ya
// se muestra ahí mismo (bloque price de sections/main-product.liquid).

function updateNuberaGiftCopy(root = document) {
  root.querySelectorAll('.nb-about__narrative').forEach((element) => {
    element.textContent = element.textContent.replace(
      'Llévalo en pack de 2 o 3 y llévate un perfume de 15ml de regalo.',
      'Tu compra incluye un perfume sorpresa de 10 ml y un atomizador de viaje, sin mínimo de productos.'
    );
  });
}

updateNuberaGiftCopy();
document.addEventListener('shopify:section:load', (event) => updateNuberaGiftCopy(event.target));

function initNuberaDefaultSize(root = document) {
  if (new URLSearchParams(window.location.search).has('variant')) return;

  root.querySelectorAll('[id^="ProductInfo-"]').forEach((productInfo) => {
    if (productInfo.dataset.nbDefaultSizeApplied === 'true') return;

    const target = [...productInfo.querySelectorAll('input[type="radio"]')].find((input) =>
      input.value.trim().toUpperCase() === '50ML' && !input.disabled
    );

    if (!target) return;

    if (!target.checked) {
      const label = document.querySelector('label[for="' + target.id + '"]');
      if (label) {
        label.click();
      } else {
        target.click();
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    productInfo.dataset.nbDefaultSizeApplied = 'true';
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => window.setTimeout(initNuberaDefaultSize, 0));
} else {
  window.setTimeout(initNuberaDefaultSize, 0);
}
document.addEventListener('shopify:section:load', (event) => initNuberaDefaultSize(event.target));

function syncNuberaProductTitle(root = document) {
  if (!window.location.pathname.startsWith('/products/')) return;

  const title = root.querySelector('[id^="ProductInfo-"] h1, h1.product__title');
  const productName = title ? title.textContent.trim() : '';
  if (productName) document.title = productName + ' | Nubera perfumes';
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => window.setTimeout(syncNuberaProductTitle, 0));
} else {
  window.setTimeout(syncNuberaProductTitle, 0);
}
document.addEventListener('shopify:section:load', (event) => syncNuberaProductTitle(event.target));

function removeNuberaWebpayReferences(root = document) {
  root.querySelectorAll('.marquee-bar__item, .shopify-section p').forEach((element) => {
    if (element.children.length > 0 || !element.textContent.includes('Webpay')) return;
    element.textContent = element.textContent
      .replaceAll('Webpay y Mercado Pago', 'Mercado Pago')
      .replaceAll('Con Webpay', 'Con tarjeta');
  });
}

removeNuberaWebpayReferences();
document.addEventListener('shopify:section:load', (event) => removeNuberaWebpayReferences(event.target));

function removeNuberaProductUrgency(root = document) {
  root.querySelectorAll('[id^="ProductInfo-"] p, [id^="ProductInfo-"] div, [id^="ProductInfo-"] span').forEach((element) => {
    if (element.children.length > 0) return;
    if (/^¡Últimas\s+/i.test(element.textContent.trim())) {
      element.textContent = 'Precio especial en 50 ml';
      element.classList.add('nb-price-urgency');
    }
  });
}

removeNuberaProductUrgency();
document.addEventListener('shopify:section:load', (event) => removeNuberaProductUrgency(event.target));

function normalizeNuberaCardPrices(root = document) {
  root.querySelectorAll('.price *, .price').forEach((element) => {
    if (element.children.length > 0) return;
    if (/A partir de \$9[.,]990 CLP/i.test(element.textContent.trim())) {
      element.textContent = '50 ml · $22.990 CLP';
    }
  });
}

function initNuberaHomeConversion(root = document) {
  if (window.location.pathname !== '/') return;

  const hero = root.querySelector('[id*=_"__hero"]');
  if (!hero) return;

  hero.querySelectorAll('h1, h2, h3').forEach((heading) => {
    const text = heading.textContent.trim();
    if (/^Más de 150 fragancias/i.test(text)) heading.textContent = 'El aroma que te encanta, sin pagar de más';
    if (/^Fragancias veganas y cruelty-free/i.test(text)) heading.textContent = 'Perfumes inspirados, veganos y cruelty-free';
  });

  hero.querySelectorAll('p').forEach((paragraph) => {
    const text = paragraph.textContent.trim();
    if (/^Inspiradas en los perfumes más icónicos/i.test(text)) paragraph.textContent = 'EDP concentrado real, 7–8 horas de duración y 2 regalos incluidos.';
    if (/^Ningún ingrediente ni prueba en animales/i.test(text)) paragraph.textContent = 'Aromas icónicos, ingredientes veganos y perfumería consciente.';
  });

  hero.querySelectorAll('a').forEach((link) => {
    if (link.textContent.trim() === 'Descubrir colección') link.textContent = 'Descubrir mis fragancias';
  });

  if (root.querySelector('.nb-home-trust')) return;

  const trust = document.createElement('section');
  trust.className = 'nb-home-trust';
  trust.setAttribute('aria-label', 'Razones para comprar en Nubera');
  trust.innerHTML = '<div class="nb-home-trust__item"><span class="nb-home-trust__icon" aria-hidden="true">★</span><strong>Clientes felices</strong><span>Reseñas reales</span></div><div class="nb-home-trust__item"><span class="nb-home-trust__icon" aria-hidden="true">⏱</span><strong>7–8 horas</strong><span>de duración</span></div><div class="nb-home-trust__item"><span class="nb-home-trust__icon" aria-hidden="true">🎁</span><strong>2 regalos</strong><span>en cada compra</span></div><div class="nb-home-trust__item"><span class="nb-home-trust__icon" aria-hidden="true">✓</span><strong>Compra segura</strong><span>Mercado Pago</span></div>';
  (hero.closest('section') || hero).insertAdjacentElement('afterend', trust);
}

// NOTA (sept 2026): initNuberaProductPromise() se eliminó a pedido del
// cliente. Insertaba, justo antes del precio (debajo del título y la
// insignia de reseñas), un mensaje genérico distinto según género del
// perfume (ej. "¿Quieres proyectar más seguridad y presencia? Una
// fragancia intensa y moderna, pensada para que te recuerden." para
// perfumes de hombre) en todas las fichas de producto.

normalizeNuberaCardPrices();
initNuberaHomeConversion();
document.addEventListener('shopify:section:load', (event) => {
  normalizeNuberaCardPrices(event.target);
  initNuberaHomeConversion(event.target);
});

(function () {
  const configs = [
    {
      match: /212\s*vip|212\s*ros/i,
      family: 'Floral · Afrutado',
      mood: 'Glamour que florece',
      occasion: 'Para citas, eventos y días en que quieres brillar.',
      notes: 'Ron dorado · rosa · flor de azahar · vainilla',
      duration: 'EDP concentrado · 7–8 h de duración'
    },
    {
      match: /good\s*girl|black\s*opium|la\s*vie|libre|miss\s*dior/i,
      family: 'Dulce · Femenino',
      mood: 'Una presencia que se recuerda',
      occasion: 'Ideal para noches, citas y ocasiones especiales.',
      notes: 'Flores blancas · vainilla · maderas cálidas',
      duration: 'EDP concentrado · aroma envolvente'
    },
    {
      match: /sauvage|invictus|one\s*million|bad\s*boy|acqua\s*di|bleu|eros/i,
      family: 'Fresco · Intenso',
      mood: 'Seguridad desde el primer spray',
      occasion: 'Para trabajar, salir y dejar una buena impresión.',
      notes: 'Cítricos · especias · maderas',
      duration: 'EDP concentrado · aroma de larga duración'
    }
  ];

  function getConfig(text) {
    return configs.find((config) => config.match.test(text)) || {
      family: 'Aroma · Nubera',
      mood: 'Tu aroma, tu momento',
      occasion: 'Una fragancia para acompañarte todos los días.',
      notes: 'Notas seleccionadas para una estela memorable',
      duration: 'EDP concentrado · perfumería vegana'
    };
  }

  function createCard(className, eyebrow, title, detail, icon) {
    const card = document.createElement('article');
    card.className = 'nb-product-story__card ' + className;
    card.innerHTML = '<span class="nb-product-story__icon" aria-hidden="true">' + icon + '</span><span class="nb-product-story__eyebrow">' + eyebrow + '</span><h3>' + title + '</h3><p>' + detail + '</p>';
    return card;
  }

  function initNuberaVisualStory(root = document) {
    if (!window.location.pathname.startsWith('/products/')) return;
    if (root.querySelector('.nb-product-story') || document.querySelector('.nb-product-story')) return;

    const gallery = root.querySelector('[id^="MediaGallery-"]');
    const productInfo = root.querySelector('[id^="ProductInfo-"]');
    if (!gallery || !productInfo) return;

    const title = productInfo.querySelector('h1, .product__title')?.textContent.trim() || '';
    const config = getConfig((productInfo.textContent + ' ' + title).toLowerCase());
    const story = document.createElement('section');
    story.className = 'nb-product-story';
    story.setAttribute('aria-label', 'Perfil visual del perfume');

    const heading = document.createElement('div');
    heading.className = 'nb-product-story__heading';
    heading.innerHTML = '<span>Conoce este aroma</span><strong>' + config.family + '</strong>';

    const track = document.createElement('div');
    track.className = 'nb-product-story__track';
    track.setAttribute('role', 'list');

    const firstImage = gallery.querySelector('img');
    if (firstImage) {
      const card = document.createElement('article');
      card.className = 'nb-product-story__card nb-product-story__card--hero';
      card.setAttribute('role', 'listitem');
      const image = document.createElement('img');
      image.src = firstImage.currentSrc || firstImage.src;
      image.alt = title;
      image.loading = 'lazy';
      card.appendChild(image);
      const overlay = document.createElement('div');
      overlay.className = 'nb-product-story__overlay';
      overlay.innerHTML = '<span class="nb-product-story__eyebrow">NUBERA PARFUMS</span><h3>' + config.mood + '</h3><p>' + config.occasion + '</p>';
      card.appendChild(overlay);
      track.appendChild(card);
    }

    const notesCard = createCard('nb-product-story__card--notes', 'Notas que vas a sentir', config.notes, config.duration, '✦');
    notesCard.setAttribute('role', 'listitem');
    track.appendChild(notesCard);

    const useCard = createCard('nb-product-story__card--use', 'Cómo se siente', config.mood, config.occasion, '◌');
    useCard.setAttribute('role', 'listitem');
    track.appendChild(useCard);

    const giftCard = createCard('nb-product-story__card--gift', 'Tu compra incluye', '50 ml + 2 regalos', 'Perfume sorpresa de 10 ml y atomizador de viaje, sin mínimo de productos.', '🎁');
    giftCard.setAttribute('role', 'listitem');
    track.appendChild(giftCard);

    story.appendChild(heading);
    story.appendChild(track);
    gallery.insertAdjacentElement('afterend', story);
  }

  initNuberaVisualStory();
  document.addEventListener('shopify:section:load', (event) => initNuberaVisualStory(event.target));
})();
(function () {
  function updateStory() {
    const story = document.querySelector('.nb-product-story');
    const productInfo = document.querySelector('[id^="ProductInfo-"]');
    if (!story || !productInfo || story.dataset.nbConceptUpdated === 'true') return;

    const title = productInfo.querySelector('h1, .product__title')?.textContent.trim() || '';
    const text = (productInfo.textContent + ' ' + title).toLowerCase();
    const female = /good\s*girl|black\s*opium|la\s*vie|libre|miss\s*dior|212\s*vip|212\s*ros|femme|mujer|coco\s*mademoiselle|paradoxe|la\s*bomba/i.test(text);
    const imageUrl = female ? 'https://tiendanubera.com/cdn/shop/files/IMG-3144.png' : 'https://tiendanubera.com/cdn/shop/files/IMG-3131.png';
    const bottleName = title.replace(/^N-\d+\s*-\s*Inspirado en\s*/i, '').trim() || 'Nubera';
    const oldUseCard = story.querySelector('.nb-product-story__card--use');
    if (oldUseCard) {
      const conceptCard = document.createElement('article');
      conceptCard.className = 'nb-product-story__card nb-product-story__card--concept nb-product-story__card--' + (female ? 'female' : 'male');
      conceptCard.setAttribute('role', 'listitem');
      const image = document.createElement('img');
      image.src = imageUrl;
      image.alt = 'Concepto ' + (female ? 'femenino' : 'masculino') + ' para ' + bottleName;
      image.loading = 'lazy';
      conceptCard.appendChild(image);
      const overlay = document.createElement('div');
      overlay.className = 'nb-product-story__overlay';
      overlay.innerHTML = '<span class="nb-product-story__eyebrow">CONCEPTO ' + (female ? 'MUJER' : 'HOMBRE') + '</span><h3>' + bottleName + '</h3><p>La personalidad de este aroma, en una imagen.</p>';
      conceptCard.appendChild(overlay);
      oldUseCard.replaceWith(conceptCard);
    }

    const giftCard = story.querySelector('.nb-product-story__card--gift');
    if (giftCard) {
      const heading = giftCard.querySelector('h3');
      if (heading) heading.textContent = 'Todas las compras';
      const detail = giftCard.querySelector('p');
      if (detail) detail.textContent = 'Decant sorpresa de 10 ml y atomizador de viaje, sin mínimo de productos.';
    }

    story.dataset.nbConceptUpdated = 'true';
  }

  updateStory();
  document.addEventListener('shopify:section:load', updateStory);
})();
(function () {
  function fixConceptLabel() {
    const productInfo = document.querySelector('[id^="ProductInfo-"]');
    const concept = document.querySelector('.nb-product-story__card--concept');
    if (!productInfo || !concept) return;

    const heading = productInfo.querySelector('h1, .product__title');
    const rawTitle = (heading?.textContent || '').replace(/\s+/g, ' ').trim();
    const bottleName = rawTitle.split(/\s+Inspirado en:\s*/i)[0].replace(/^N-\d+\s*-\s*Inspirado en\s*/i, '').trim() || 'Nubera';
    const title = concept.querySelector('h3');
    if (title) title.textContent = bottleName;

    let label = concept.querySelector('.nb-product-story__label');
    if (!label) {
      label = document.createElement('span');
      label.className = 'nb-product-story__label';
      label.setAttribute('aria-hidden', 'true');
      concept.appendChild(label);
    }
    label.textContent = bottleName;
  }

  fixConceptLabel();
  document.addEventListener('shopify:section:load', fixConceptLabel);
})();
(function () {
  function fixConceptLabelName() {
    const productInfo = document.querySelector('[id^="ProductInfo-"]');
    const concept = document.querySelector('.nb-product-story__card--concept');
    if (!productInfo || !concept) return;
    const heading = productInfo.querySelector('h1, .product__title');
    const rawTitle = (heading?.textContent || '').replace(/\s+/g, ' ').trim();
    const titleBeforeReference = rawTitle.split(/\s+Inspirado en:\s*/i)[0];
    const bottleName = titleBeforeReference.split(/N-\d+\s*-\s*Inspirado en\s*/i).pop().trim() || 'Nubera';
    const title = concept.querySelector('h3');
    if (title) title.textContent = bottleName;
    const label = concept.querySelector('.nb-product-story__label');
    if (label) label.textContent = bottleName;
  }
  fixConceptLabelName();
  document.addEventListener('shopify:section:load', fixConceptLabelName);
})();
(function () {
  function removeVisualStory() {
    document.querySelectorAll('.nb-product-story').forEach((element) => element.remove());
  }

  removeVisualStory();
  document.addEventListener('shopify:section:load', removeVisualStory);
})();